import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const HeroSection = () => {
  return (
    <section className="min-h-screen pt-20 flex items-center justify-center px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-background via-background/95 to-background/90 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute w-96 h-96 bg-primary/10 rounded-full blur-3xl top-20 -right-48 animate-float"></div>
      <div className="absolute w-80 h-80 bg-accent/10 rounded-full blur-3xl -bottom-20 -left-20 animate-float"></div>
      
      <div className="max-w-7xl mx-auto text-center relative z-10 py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-foreground mb-6 leading-tight">
            <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              Crie Conteúdo Incrível
            </span>
            <br />
            Para Suas Redes Sociais
          </h1>
          
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto mb-8 leading-relaxed">
            Transforme suas ideias em memes, vídeos e músicas impressionantes usando as melhores ferramentas de IA como ChatGPT, Deep AI, Clideo e muito mais. Tudo em um só lugar.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg px-8"
              onClick={() => toast.info("Recurso de criação em breve!")}
            >
              Começar a Criar
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-primary text-foreground hover:bg-primary/10"
              onClick={() => toast.info("Tutoriais em breve!")}
            >
              Ver Tutoriais
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-accent text-foreground hover:bg-accent/10"
              onClick={() => window.open("https://studio.youtube.com/channel/UC-20RsfqftBP6yKfOUHEdsA", "_blank")}
            >
              Inscreva-se no Canal
            </Button>
          </div>
          
          <div className="mt-16 grid grid-cols-2 md:grid-cols-5 gap-4 text-center">
            <div className="p-4">
              <div className="text-2xl font-bold text-primary mb-1">ChatGPT</div>
              <p className="text-muted-foreground">Gere textos e ideias</p>
            </div>
            <div className="p-4">
              <div className="text-2xl font-bold text-primary mb-1">Deep AI</div>
              <p className="text-muted-foreground">Crie imagens e vídeos</p>
            </div>
            <div className="p-4">
              <div className="text-2xl font-bold text-primary mb-1">Clideo</div>
              <p className="text-muted-foreground">Edite seus vídeos</p>
            </div>
            <div className="p-4">
              <div className="text-2xl font-bold text-primary mb-1">Rumble</div>
              <p className="text-muted-foreground">Compartilhe seu conteúdo</p>
            </div>
            <div className="p-4">
              <div className="text-2xl font-bold text-primary mb-1">YouTube</div>
              <p className="text-muted-foreground">
                <a href="https://www.youtube.com/live/B1CdO1-2asA" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground underline transition-colors">Assista ao vivo</a>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;